<i [ngClass]="getStateIcon()" class="fa" aria-hidden="true"></i>
